export const featureFlags = {
  suiteShell: import.meta.env.VITE_FEATURE_SUITE_SHELL === 'true',
  dcoApproval: import.meta.env.VITE_FEATURE_DCO_APPROVAL === 'true',
} as const;

export type FeatureFlag = keyof typeof featureFlags;

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
